<template>
    <div class="MenuSide-MAIN">

        <img src="../assets/ApArt-Logo-Black.png" @click="setView('parenthesis')"/>
        <hr/>
        <div>
            <div><img src="../assets/icon-person.png"/></div>
            <div><img src="../assets/icon-inbox.png"/></div>
            <!--<div><img src="../assets/icon-bookmark.png"/></div>
            <div><img src="../assets/icon-ap.png"/></div>-->
            <div><img src="../assets/icon-settings.png"/></div>
            <div @click="setView('about')"><img src="../assets/icon-question-mark-circle.png"/></div>
        </div>

    </div>
</template>

<script>
export default{
    name: 'MenuSide',
    data(){
        return{
            
        }
    },
    methods: {
        setView(view){
            this.$parent.toggleSideMenu(false);
            this.$router.push({ name: view });
        }
    }
}
</script>

<style scoped lang="stylus">
.MenuSide-MAIN
    height: 100vh
    background-color: #DCDCDC
    width: 20vw
    min-width: 20vw
    border-radius: 10vw 0 0 10vw
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    z-index: 1

    >img
        width:75%;
        cursor: pointer

    >div
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center

        div
            width: 8vw
            aspect-ratio: 1/1
            margin: 1vh 0

            img
                max-width: 100%
                max-height: 100%
                cursor: pointer

        :nth-child(4) img
            scale: 0.65

hr
    width:75%
    margin-top: 3vw
    border-top: 1px solid #707070
</style>